import type { GetCourseDetailUserEnrollmentsByCourseQueryQuery } from '../graphql/get-course-detail-user-enrollments-by-course-query.v5.generated';
import type { TCourseDetailUserEnrollment } from '../types';

type TNode = Extract<
  GetCourseDetailUserEnrollmentsByCourseQueryQuery['enrollments']['get_users_by_assigned_courses_with_search'],
  { __typename?: 'UserCourseInfoConnection' }
>['edges'][number]['node'];

export const transformEnrollmentUser = (
  node: TNode,
): TCourseDetailUserEnrollment => {
  return {
    centralizedUserId: node.centralized_user_id,
    firstName: node.first_name,
    lastName: node.last_name,
    email: node.email,
    avatar: node.avatar ?? undefined,
  };
};
